const KEYNAV_CLASS = 'is-keynav';

export function setupKeynav() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', doSetupKeynav);
  } else {
    doSetupKeynav();
  }
}

function doSetupKeynav() {
  document.body.addEventListener('keyup', (event) => {
    if (event.key === 'Tab') {
      startKeyboardNavigation();
    }
  });
  document.body.addEventListener('pointerdown', () => endKeyboardNavigation());
}

export function isKeyboardNavigation() {
  return document.body.classList.contains(KEYNAV_CLASS);
}

export function startKeyboardNavigation() {
  document.body.classList.add(KEYNAV_CLASS);
}

function endKeyboardNavigation() {
  document.body.classList.remove(KEYNAV_CLASS);
}
